import React from 'react';
import { TextField, makeStyles } from '@applyboard/ui-components';
import InputLabelWrapper from "../InputLabelWrapper";
import ErrorMessage from "../ErrorMessage";
var useStyles = makeStyles({
  textfield: {
    marginBottom: 0,
    '& label': {
      top: '-5px'
    }
  }
});
function NumberInput(_ref) {
  var error = _ref.error,
    id = _ref.id,
    label = _ref.label,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    touched = _ref.touched,
    value = _ref.value;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
    error: touched && !!error,
    fullWidth: true,
    id: id
    // As of June 21, 2021, from https://material-ui.com/components/text-fields/#shrink:
    //   "The input label is supposed to shrink as soon as the input is displaying something.
    //    In some circumstances, we can't determine the "shrink" state (number input, datetime
    //    input, Stripe input). You might notice an overlap."
    // As a "number" input, that overlap was reported in STUJ-344.  Here, we apply the suggested
    // fix:
    //   "To workaround the issue, you can force the "shrink" state of the label."
    ,
    InputLabelProps: {
      shrink: true
    },
    label: /*#__PURE__*/React.createElement(InputLabelWrapper, null, label),
    margin: "normal",
    onBlur: onBlur,
    onChange: onChange,
    type: "number",
    value: value,
    variant: "outlined",
    className: classes.textfield
  }), touched && !!error && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ErrorMessage, {
    message: error
  })));
}
export default NumberInput;